module.exports = __webpack_public_path__ + "img/battery-black.287964a7.svg";